
import Vue from 'vue'
import Component from 'vue-class-component'
import { getPhpProtocol } from '@/api'
import { Toast } from 'vant'
import loadingLottieAll from '@/components/loadingLottieAll.vue'
import { replaceAll } from '@/common'
@Component({
  components: {
    loadingLottieAll,
  },
})
export default class IndexView extends Vue {
  content = ''
  contentReg = /326.7pt/g // 需要去除的样式
  param: any = {}
  loading: boolean = false

  created() {
    this.param = this.$route.params
    this.getLoginProtocol(this.param.pType)
  }
  getLoginProtocol(type: number | string) {
    let title = ''
    if (type === 0 || type === '0') {
      title = 'capp_sign'
    } else {
      title = 'capp_privacy_V2.10'
    }
    const param = {
      title: title,
    }
    this.loading = true
    getPhpProtocol(param)
      .then((res: any) => {
        this.loading = false
        if (res.code === 0 && res.data) {
          // 去除meta设置
          let con = replaceAll(res.data?.content, 'apple-mobile-web-app-capable', '')
          con = replaceAll(con, 'format-detection', '')
          con = replaceAll(con, 'viewport', '')
          con = replaceAll(con, '<!DOCTYPE html>', '')
          con = replaceAll(con, '<html lang="zh-CN">', '')
          con = replaceAll(con, '</html>', '')
          this.content = con
        } else {
          Toast({
            message: res.msg || '协议详情获取失败',
          })
        }
      })
      .catch(() => {
        this.loading = false
        Toast({
          message: '协议详情获取失败',
        })
      })
  }
}
